var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React, { Fragment } from 'react';
import { Field } from 'redux-form';
import Dropdown from '../Field/Dropdown';
import FieldValidationMessage from '../FieldValidationMessage/FieldValidationMessage';

var DropdownComponent = function DropdownComponent(_ref) {
  var meta = _ref.meta,
      input = _ref.input,
      placeholder = _ref.placeholder,
      rest = _objectWithoutProperties(_ref, ['meta', 'input', 'placeholder']);

  return React.createElement(Fragment, null, React.createElement(Dropdown, _extends({
    placeholder: placeholder
  }, input, rest)), React.createElement(FieldValidationMessage, meta));
};

var DropdownField = function DropdownField(_ref2) {
  var label = _ref2.label,
      name = _ref2.name,
      placeholder = _ref2.placeholder,
      validate = _ref2.validate,
      options = _ref2.options,
      isDisabled = _ref2.isDisabled;
  return React.createElement('div', {
    className: 'form-group'
  }, React.createElement('label', {
    className: 'control-label'
  }, label), React.createElement(Field, {
    isDisabled: isDisabled,
    name: name,
    options: options,
    placeholder: placeholder,
    component: DropdownComponent,
    validate: validate
  }));
};

export default DropdownField;